import { createFileRoute } from "@tanstack/react-router";
import { mcpConnectionLinkApiRoute } from "@/features/mcp-connections";

export const Route = createFileRoute("/api/internal/mcp-connections/link")({
    ...mcpConnectionLinkApiRoute,
});
